import { render } from "./MyNotesMain.vue?vue&type=template&id=21ecca26&scoped=true"
import script from "./MyNotesMain.vue?vue&type=script&lang=js"
export * from "./MyNotesMain.vue?vue&type=script&lang=js"

import "./MyNotesMain.vue?vue&type=style&index=0&id=21ecca26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ecca26"]])

export default __exports__